import React, { useEffect } from 'react';
import { useParams, useNavigate } from 'react-router';
import { useAuthenticator } from '@aws-amplify/ui-react';

import { getSensorsById, getTempUser } from '../../state/selectors';
import Loading from '../../components/Loading';
import { handleLogout } from '../../Shell/helpers';
import { setSensorsById, setTempUser } from '../../state/actions';
import { fetchSensorLatest } from '../../services/apiService';
import { useAppSelector, useAppDispatch } from '../../state/store';

function AppAdminSensor(): JSX.Element {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const { user } = useAuthenticator((context) => [context.user]);
  const { sensorId } = useParams() as { sensorId: string };
  const tempUser = useAppSelector(getTempUser);
  const sensorsById = useAppSelector(getSensorsById);
  const sensorDetail = sensorsById.get(sensorId);

  // eslint-disable-next-line consistent-return
  const renderComponent = () => {
    // checking with sensorsById record size to make sure store already has some data
    if (sensorsById.size > 0) {
      if (sensorDetail) navigate(`/sensors/${sensorId}`);
      else {
        fetchSensorLatest(sensorId)
          .then((details) => {
            if (details) {
              navigate(`/sensors/${sensorId}`);
              dispatch(setSensorsById([details]));
            }
          })
          .catch((err) => {
            const resStatus = err?.cause?.status ?? undefined;
            if (resStatus === 404) navigate(`/install/${sensorId}`);
          });
      }
    }
  };

  // this page only render component for authenticated users, if only tempuser is found redirect user with login process
  useEffect(() => {
    if (!user) {
      dispatch(setTempUser(null));
      handleLogout(tempUser, dispatch, navigate);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    // eslint-disable-next-line react/jsx-no-useless-fragment
    <>
      {user && (
        <>
          {sensorsById.size === 0 && <Loading />}
          {renderComponent()}
        </>
      )}
    </>
  );
}

export default AppAdminSensor;
